var _g, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoSiteMarkerActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_339_1332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4063 30.7409C33.4063 30.7409 33.4144 30.7312 33.4176 30.7264C33.4192 30.7232 33.4225 30.72 33.4225 30.72C34.7278 28.9756 35.5 26.8126 35.5 24.4691C35.5 18.6869 30.7989 14 25.0008 14C19.2027 14 14.5 18.6869 14.5 24.4691C14.5 26.8126 15.2722 28.9756 16.5775 30.72C16.5775 30.72 16.5808 30.7248 16.5824 30.7264C16.5856 30.7312 16.5905 30.7361 16.5937 30.7409C16.6163 30.7715 16.668 30.8359 16.7456 30.9342C16.8619 31.0807 16.9798 31.2241 17.1042 31.3642C18.1688 32.606 20.8409 35.4407 25.0008 38C29.1607 35.4407 31.8328 32.606 32.8974 31.3642C33.0202 31.2241 33.1397 31.0807 33.2561 30.9342C33.3336 30.8375 33.3853 30.7715 33.4079 30.7409H33.4063Z",
    fill: "#007D8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8324 30.2566C32.8271 30.2633 32.8209 30.2713 32.8141 30.2807C32.8034 30.2944 32.7933 30.3084 32.7837 30.3227C32.7617 30.3511 32.7247 30.3979 32.6711 30.4648L32.6686 30.4679C32.5598 30.605 32.448 30.739 32.3333 30.8699L32.3333 30.8699L32.328 30.8761C31.3307 32.0394 28.8509 34.6754 25.0008 37.1158C21.1507 34.6754 18.671 32.0394 17.6736 30.876L17.6737 30.876L17.6651 30.8663C17.5528 30.7399 17.4441 30.6079 17.333 30.4679L17.2376 30.3473L17.2081 30.3097L17.1995 30.2987C17.1992 30.2982 17.1989 30.2978 17.1986 30.2974C17.1973 30.2956 17.196 30.2939 17.1948 30.2922C17.1884 30.2836 17.1827 30.2764 17.1784 30.2709L17.1766 30.2687C15.9658 28.6498 15.25 26.6441 15.25 24.4691C15.25 19.1034 19.6147 14.75 25.0008 14.75C30.3867 14.75 34.75 19.1032 34.75 24.4691C34.75 26.6387 34.0378 28.6399 32.8324 30.2566ZM17.1635 30.2527C17.1632 30.2522 17.1632 30.2523 17.1634 30.2526C17.1635 30.2526 17.1635 30.2527 17.1636 30.2528L17.1635 30.2527Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 24,
    r: 3,
    fill: "white",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_339_1332",
    x: 0.5,
    y: 0,
    width: 49,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.167457 0 0 0 0 0.840706 0 0 0 0 0.762161 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_339_1332"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_339_1332",
    result: "effect2_dropShadow_339_1332"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_339_1332",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSiteMarkerActive);
export default __webpack_public_path__ + "static/media/ico-site-marker-active.2829c95f6f325b34983c294b1b0820a4.svg";
export { ForwardRef as ReactComponent };